import React, { useEffect, useState } from 'react';
import './style.scss';
import trash from '../../Images/Common/trash.svg';
import Loading from '../SingleLoadingImage';
import ErrorImage from '../ErrorImage';
import miscApi from '../../apis/misc';
import { useSelector } from 'react-redux';
import {
  deleteImageForStepWiseUserData,
  resetForStepWiseUserData,
  updateStepWiseUserDataForImages,
} from '../../redux/Reducers/userStepsDataDetailReducer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const { getPresignedUrl, putImageToS3, getThumbPathOfImage } = miscApi;

const SelectSingleImage = ({
  item,
  isDelete,
  mainWrapperClass,
  showLoadingText = true,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uploaded_files = useSelector(
    (state) => state.userStepsDataDetailReducer.stepUploadImages.files
  );

  const [progress, setProgress] = useState(0);
  const [isFailed, setIsFailed] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleImageUpdate = async (itm, status) => {
    let files = [...uploaded_files];
    let itemIndex = files?.findIndex((img) => img?._id === item?._id);
    files[itemIndex] = itm;
    dispatch(
      updateStepWiseUserDataForImages({
        itemIndex,
        itm,
      })
    );

    if (status === 'success') {
      setIsLoading(false);
      setIsSuccess(true);
      setIsFailed(false);
    }

    if (status === 'failed') {
      setIsLoading(false);
      setIsSuccess(false);
      setIsFailed(true);
    }
  };

  useEffect(() => {
    if (item?.isLoading) {
      let file = item?.file;
      console.log('file', file);
      getPresignedUrl({
        filename: item?.fileName,
        mimeType: file?.type,
        requestType: 'modelClipper',
      })
        .then(async (res) => {
          const { url, key } = res?.data;
          await putImageToS3(url, file, setProgress)
            .then((res) => {
              //
              console.log('res', res);
              getThumbPathOfImage({ key })
                .then((resp) => {
                  handleImageUpdate(
                    {
                      ...item,
                      isLoading: false,
                      isSuccess: true,
                      isGeneratedKey: true,
                      generatedUrl: url,
                      generatedKey: key,
                      thumbImageUrl: resp?.data?.data?.thumbPath?.url,
                    },
                    'success'
                  );
                })
                .catch((err) => {
                  console.log(err);
                  handleImageUpdate(
                    {
                      ...item,
                      isLoading: false,
                      isFailed: true,
                    },
                    'failed'
                  );
                });
            })
            .catch((err) => {
              console.log(err);
              handleImageUpdate(
                {
                  ...item,
                  isLoading: false,
                  isFailed: true,
                },
                'failed'
              );
            });
        })
        .catch((err) => {
          console.log(err);
          handleImageUpdate(
            { ...item, isLoading: false, isFailed: true },
            'failed'
          );
        });
    } else if (item?.isSuccess) {
      setIsLoading(false);
      setIsSuccess(true);
      setIsFailed(false);
    } else if (item?.isFailed) {
      setIsLoading(false);
      setIsSuccess(false);
      setIsFailed(true);
    }
  }, []);

  const handleImageDelete = () => {
    let filesLength = uploaded_files?.length;
    if (filesLength === 1) {
      dispatch(resetForStepWiseUserData({}));
      navigate('/');
    } else {
      dispatch(
        deleteImageForStepWiseUserData({
          id: item?._id,
        })
      );
    }
  };

  const getLoading = () => {
    return (
      <div
        className={`image_wrapper_main ${
          mainWrapperClass ? mainWrapperClass : ''
        }`}
      >
        <Loading
          waitingTitle={'Uploading'}
          waitingSubTitle={'Please wait...'}
          wrapperClass={'loading_wrapper'}
          showText={showLoadingText}
        />
      </div>
    );
  };

  const getFailed = () => {
    return (
      <div
        className={`image_wrapper_main ${
          mainWrapperClass ? mainWrapperClass : ''
        }`}
      >
        <ErrorImage
          errorMessage="There is some error"
          errorSubMessage="Please try again later"
          wrapperClass={'error_wrapper'}
        />
      </div>
    );
  };

  if (isLoading) {
    return getLoading();
  }

  if (isFailed) {
    return getFailed();
  }

  return (
    <div
      className={`image_wrapper_main ${
        mainWrapperClass ? mainWrapperClass : ''
      }`}
    >
      {isSuccess && (
        <img
          src={item?.thumbImageUrl}
          alt={item?._id}
          className="modelImage"
          onLoad={() => {}}
        />
      )}
      {isDelete && (
        <img
          src={trash}
          alt={'deleteIcon'}
          className="trashIcon"
          onClick={handleImageDelete}
        />
      )}
      {/* {getLoading()} */}
    </div>
  );
};
export default SelectSingleImage;
